import { useEffect, useRef } from "react";

export const useInterval = (callback, delay: number | null) => {
  const savedCallback = useRef<ReturnType<typeof setInterval> | null>(null);

  // Remember the callback
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval
  useEffect(() => {
    function tick() {
      if (savedCallback) {
        savedCallback.current();
      }
    }

    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
